
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { toast } from "sonner";

interface ConfirmationDialogProps {
  isOpen: boolean;
  title: string;
  description: string;
  actionLabel: string;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  children?: React.ReactNode;
}

export default function ConfirmationDialog({
  isOpen,
  title,
  description,
  actionLabel,
  onClose,
  onConfirm,
  children
}: ConfirmationDialogProps) {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        {children}
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={async () => {
              try {
                await onConfirm();
                onClose();
              } catch (error: any) {
                console.error('[ConfirmationDialog] onConfirm error:', error);
                toast.error(
                  error?.message || 'Action failed. Please try again.'
                );
              }
            }}
          >
            {actionLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
